import { render, staticRenderFns } from "./InstallOvpn.vue?vue&type=template&id=319cdcc3&"
import script from "./InstallOvpn.vue?vue&type=script&lang=js&"
export * from "./InstallOvpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports